export const GBP = new Intl.NumberFormat("en-GB", {
  style: "currency",
  currency: "GBP",
  maximumFractionDigits: 0,
});

export const GBP2 = new Intl.NumberFormat("en-GB", {
  style: "currency",
  currency: "GBP",
  maximumFractionDigits: 2,
});

export const NUM = new Intl.NumberFormat("en-GB", { maximumFractionDigits: 0 });
export const NUM2 = new Intl.NumberFormat("en-GB", { maximumFractionDigits: 2 });

export function fmtKwh(v) {
  if (v == null) return "—";
  if (v >= 1_000_000) return `${(v / 1_000_000).toFixed(2)} GWh`;
  if (v >= 1000) return `${(v / 1000).toFixed(1)} MWh`;
  return `${NUM.format(v)} kWh`;
}

export function fmtKwp(v) {
  if (v == null) return "—";
  return `${NUM2.format(v)} kWp`;
}

export function fmtDateGB(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  // Strict DD/MM/YYYY across the whole app — day/month/year all numeric.
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" });
}

export function fmtDateTimeGB(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString("en-GB", {
    day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit",
  });
}

export function statusLabel(s) {
  return ({
    design: "Design",
    quote_draft: "Quote Draft",
    quote_sent: "Quote Sent",
    approved: "Approved",
    installing: "Installing",
    monitoring: "Monitoring",
    completed: "Completed",
    cancelled: "Cancelled",
    not_started: "Not Started",
    in_progress: "In Progress",
    blocked: "Blocked",
    done: "Done",
    draft: "Draft",
    sent: "Sent",
    customer_approved: "Customer Approved",
    manager_approved: "Manager Approved",
    rejected: "Rejected",
  }[s] || s);
}

export function statusTone(s) {
  if (["done", "completed", "manager_approved", "customer_approved", "approved", "monitoring"].includes(s)) return "ok";
  if (["in_progress", "installing", "quote_sent", "sent"].includes(s)) return "signal";
  if (["blocked", "rejected", "cancelled"].includes(s)) return "err";
  return "";
}

// Compact UK axis tick: "DD/MM" for daily ISO strings, otherwise unchanged.
export function ukShort(v) {
  const s = String(v || "");
  return /^\d{4}-\d{2}-\d{2}/.test(s) ? `${s.slice(8, 10)}/${s.slice(5, 7)}` : s;
}
